import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { BlockWidths } from '../../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from '../blockMutualStyle';


interface CerosDataProps {
    html: string;
    dataId?: string;
    defaultBlocksWidths: BlockWidths;
}

const getStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
    },
  }).style;
};

type CerosProps = CerosDataProps & MandatoryAdditionalStyle;

export const Ceros: React.FunctionComponent<CerosProps> = props => {
  const { html, additionalStyle, dataId, defaultBlocksWidths } = props;
  const style = getStyle(defaultBlocksWidths);
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src="https://static.apester.com/js/sdk/latest/apester-sdk.js" />
      </Helmet>
      <div className={css(additionalStyle.style, style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-mm-id={dataId} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ErrorBoundary>
  );
};
